<template>
    <h5 class="subtitle is-5 mb-5">These settings affect the checks being run on each leg and the LevelFlight data polling.</h5>

    <SettingsInput
        label="Block Time Threshold (minutes)"
        description="During the Times check, the threshold of time difference to flag planned times vs pilot recorded times"
        :min="1"
        settingKey="blockTimeThreshold"
        placeholder="Must be positive"
        :validator="validateBlockTimeThreshold"
    />
</template>

<script>
import SettingsInput from './SettingsInput.vue';

export default {
    components: { SettingsInput },
    setup() {
        const validateBlockTimeThreshold = (value) => value >= 1 ? null : 'Block time threshold must be at least 1 minute.';

        return {
            validateBlockTimeThreshold,
        };
    },
}
</script>